module.exports = __webpack_public_path__ + "static/media/LindenLogo.710a3ff7.svg";